import {
  OrderPaginationQueryKeys,
  OrderSortingKeys,
  SortOrder,
  type OrderPaginationQueryParams,
  type PaginationConfig,
} from '@centric-os/types';
import { DateTime } from 'luxon';

export const defaultOrderPaginationConfig: PaginationConfig = {
  // @ts-expect-error FIXME: type assignment error (TS2322)
  queryParams: <OrderPaginationQueryParams>{
    [OrderPaginationQueryKeys.LIMIT]: 25,
    [OrderPaginationQueryKeys.PAGE]: 1,
    [OrderPaginationQueryKeys.SORT_BY]: OrderSortingKeys.DATE_CREATED,
    [OrderPaginationQueryKeys.SORT_ORDER]: SortOrder.DESC,
    [OrderPaginationQueryKeys.DATE_CREATED_START]: DateTime.local().startOf('day').toUTC().toISO(),
    [OrderPaginationQueryKeys.DATE_CREATED_END]: DateTime.local().endOf('day').toUTC().toISO(),
    [OrderPaginationQueryKeys.SOURCE_ID]: undefined,
    [OrderPaginationQueryKeys.PICKUP_NAME]: undefined,
    [OrderPaginationQueryKeys.PICKUP_ID]: undefined,
    [OrderPaginationQueryKeys.SOURCE_GROUP_ID]: undefined,
    [OrderPaginationQueryKeys.SOURCE_BRAND_ID]: undefined,
    [OrderPaginationQueryKeys.REFUND_STATUS]: undefined,
    [OrderPaginationQueryKeys.PAYMENT_CATEGORY]: undefined,
    [OrderPaginationQueryKeys.EMAIL]: undefined,
    [OrderPaginationQueryKeys.ORDER_TYPE]: undefined,
    [OrderPaginationQueryKeys.STATUS]: undefined,
  },
  metaParams: {
    resultCount: 0,
    totalPages: 1,
    totalResults: 0,
  },
};
